import { createSelector } from 'reselect';
import customIsoString from 'utilities/custom-iso-string';

const getTasks      = (state)  => state.task.entities;
const getAgendaVisiblity = (state) => state.agenda;
const getDate = (state, props) => props.date;

const getTasksByDate = createSelector(
    [getTasks, getDate, getAgendaVisiblity],
    (tasks, date, agendaVisibility) => {

        let allTasks = tasks.allIds.map(taskId => tasks.byId[taskId]);

        let stringDate = customIsoString(date).slice(0,10);

        allTasks = allTasks.filter((task, index) => task.date == stringDate);

        if(!agendaVisibility.other_task) {
            allTasks = allTasks.filter((task, index) => task.homework_id != null);
        }

        return allTasks;
    }
);

export default getTasksByDate;
